import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import VoiceNote from "../voice/VoiceNote";
import { rupees } from "../rates/rateModel";
import { KIND_LABEL } from "./payModel";
import { useKT } from "../i18n/kt";

/**
 * Taking money back needs a reason — spoken (voice note) or written. A supervisor's request goes to
 * the owner / a manager to approve and the money keeps counting until then, so nobody can quietly
 * reverse a payment to favour someone. The owner or a manager takes it back at once.
 */
const TakeBackDialog = ({
  entry,
  approverHere,
  busy,
  onCancel,
  onSend,
}: {
  entry: any | null;
  /** The signed-in person can take it back straight away (owner / manager). */
  approverHere: boolean;
  busy: boolean;
  onCancel: () => void;
  onSend: (body: { note?: string; voiceNoteUrl?: string }) => void;
}) => {
  const { t } = useKT();
  const [note, setNote] = useState("");
  const [voice, setVoice] = useState<string | null>(null);

  useEffect(() => {
    setNote("");
    setVoice(null);
  }, [entry]);

  if (!entry) return null;
  return (
    <Modal isOpen={!!entry} toggle={onCancel} centered>
      <ModalHeader toggle={onCancel}>
        {t("Take back {{what}} of {{amount}}?", { what: t(KIND_LABEL[entry.kind] || "entry"), amount: rupees(entry.amount) })}
      </ModalHeader>
      <ModalBody>
        <p className="kw-muted" style={{ marginTop: 0 }}>
          {approverHere
            ? t("Say why. It is taken back now and the reason is kept.")
            : t("Say why — record it or write it. The owner or a manager approves it; until then the money still counts.")}
        </p>
        <VoiceNote value={voice} onChange={setVoice} />
        <label className="kr-label mt-2" htmlFor="ktb-note">
          {t("Or write the reason")}
        </label>
        <textarea id="ktb-note" className="kd-dialog__input" rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder={t("e.g. paid to the wrong person")} />
      </ModalBody>
      <ModalFooter>
        <button type="button" className="kh-btn" onClick={onCancel}>
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="kh-btn is-primary is-danger"
          disabled={busy || (!note.trim() && !voice)}
          onClick={() => onSend({ ...(note.trim() ? { note: note.trim() } : {}), ...(voice ? { voiceNoteUrl: voice } : {}) })}
        >
          {busy ? t("Saving…") : approverHere ? t("Take back") : t("Send for approval")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default TakeBackDialog;
